function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { sortDate } from '../../utils/sort.js';
import { isNumber, isDate, isObject } from '../../utils/is.js';
export default {
  props: {
    sortMethod: {
      type: Function,
      "default": function _default(data, sortBy, descending) {
        var col = this.colList.find(function (def) {
          return def.name === sortBy;
        });

        if (col === void 0 || col.field === void 0) {
          return data;
        }

        var dir = descending === true ? -1 : 1,
            val = typeof col.field === 'function' ? function (v) {
          return col.field(v);
        } : function (v) {
          return v[col.field];
        };
        return data.sort(function (a, b) {
          var A = val(a),
              B = val(b);

          if (A === null || A === void 0) {
            return -1 * dir;
          }

          if (B === null || B === void 0) {
            return 1 * dir;
          }

          if (col.sort !== void 0) {
            return col.sort(A, B, a, b) * dir;
          }

          if (isNumber(A) === true && isNumber(B) === true) {
            return (A - B) * dir;
          }

          if (isDate(A) === true && isDate(B) === true) {
            return sortDate(A, B) * dir;
          }

          if (typeof A === 'boolean' && typeof B === 'boolean') {
            return (A - B) * dir;
          }

          var _map = [A, B].map(function (s) {
            return (s + '').toLocaleString().toLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          A = _map2[0];
          B = _map2[1];
          return A < B ? -1 * dir : A === B ? 0 : dir;
        });
      }
    },
    columnSortOrder: {
      type: String,
      validator: function validator(v) {
        return v === 'ad' || v === 'da';
      },
      "default": 'ad'
    }
  },
  computed: {
    columnToSort: function columnToSort() {
      var sortBy = this.computedPagination.sortBy;

      if (sortBy) {
        return this.colList.find(function (def) {
          return def.name === sortBy;
        }) || null;
      }
    }
  },
  methods: {
    sort: function sort(col
    /* String(col name) or Object(col definition) */
    ) {
      var sortOrder = this.columnSortOrder;

      if (isObject(col) === true) {
        if (col.sortOrder) {
          sortOrder = col.sortOrder;
        }

        col = col.name;
      } else {
        var def = this.colList.find(function (def) {
          return def.name === col;
        });

        if (def !== void 0 && def.sortOrder) {
          sortOrder = def.sortOrder;
        }
      }

      var _this$computedPaginat = this.computedPagination,
          sortBy = _this$computedPaginat.sortBy,
          descending = _this$computedPaginat.descending;

      if (sortBy !== col) {
        sortBy = col;
        descending = sortOrder === 'da';
      } else if (this.binaryStateSort === true) {
        descending = !descending;
      } else if (descending === true) {
        if (sortOrder === 'ad') {
          sortBy = null;
        } else {
          descending = false;
        }
      } else {
        // ascending
        if (sortOrder === 'ad') {
          descending = true;
        } else {
          sortBy = null;
        }
      }

      this.setPagination({
        sortBy: sortBy,
        descending: descending,
        page: 1
      });
    }
  }
};